export const triggerSurvey = ({ surveyId }) => {
    if (typeof Iterate !== 'undefined' && surveyId) {
        Iterate('install', surveyId);
    }
};
